"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateMerkleHash = calculateMerkleHash;
const utils_1 = require("../gtv/utils");
const crypto_1 = require("../crypto");
const constants_1 = require("../constants");
function calculateNodeHash(prefix, leftHash, rightHash) {
    return (0, crypto_1.sha256)(Buffer.concat([Buffer.from([prefix]), leftHash, rightHash]));
}
function calculateLeafHash(gtv) {
    const ret = (0, crypto_1.sha256)(Buffer.concat([Buffer.from([constants_1.HASH_PREFIX_LEAF]), Buffer.from((0, utils_1.encode_value)(gtv))]));
    return ret;
}
function calculateMerkleHash(element) {
    if (element.type === 'empty')
        return Buffer.alloc(32);
    if (element.type === 'leaf')
        return calculateLeafHash(element.content);
    const prefix = 'kind' in element
        ? element.kind === 'array' ? constants_1.HASH_PREFIX_NODE_ARRAY : constants_1.HASH_PREFIX_NODE_DICT
        : constants_1.HASH_PREFIX_NODE;
    return calculateNodeHash(prefix, calculateMerkleHash(element.left), calculateMerkleHash(element.right));
}
//# sourceMappingURL=hash.js.map